<template>
  <!-- Preview with editor code -->
  <div v-if="!deploymentMode" class="container-badge" ref="badgeContent">
    <div
      class="position-relative shadow-lg mx-auto ratio"
      :style="cardStyle"
      @click.stop.prevent
      ref="badgeBackground"
    >
      <img
        v-if="cardBackground"
        class="top-0 left-0 position-absolute w-100 h-100"
        :src="cardBackground"
        alt=""
      />
      <div class="w-100 h-100" @click="itemClick(-1)"></div>
      <div
        v-if="snapToGrid"
        class="w-100 h-100"
        :style="gridStyle"
        style="pointer-events: none"
      ></div>
      <div v-if="isLoaded && itemList && itemList.length <= 0" class="w-100 h-100">
        <div class="mt-5 row">
          <div class="mx-auto mt-5 text-center col-auto">
            <h3 class="text-muted">Le badge ne comporte pas encore d'éléments</h3>
            <h4 class="text-muted">Cliquez ci-dessous ou sur le menu lateral pour en ajouter</h4>
          </div>
        </div>
        <div class="mt-5 row">
          <div class="ms-auto text-center col-auto">
            <button @click="addItems('text')" class="px-4 py-3 btn-outline-secondary fw-bold btn">
              <i class="pb-2 fas fa-font fa-3x"></i><br />Ajouter un Texte
            </button>
          </div>
          <div class="text-center col-auto">
            <button @click="addItems('image')" class="px-4 py-3 btn-outline-secondary fw-bold btn">
              <i class="fa-photo-video pb-2 fas fa-3x"></i><br />Ajouter une Image
            </button>
          </div>
          <div class="me-auto text-center col-auto">
            <button
              @click="addItems('qr-code')"
              class="px-4 py-3 btn-outline-secondary fw-bold btn"
            >
              <i class="pb-2 fas fa-qrcode fa-3x"></i><br />Ajouter un Qr code
            </button>
          </div>
        </div>
      </div>
      <template v-else-if="isLoaded">
        <template v-if="this.badgeContent.origin === 'papillon'">
          <div class="eyelet papillonEyelet" :style="badgeOverlayStyles.papillonEyelet"></div>
          <div v-if="badgeOverlayStyles.papillonEyelet2" class="eyelet papillonEyelet" :style="badgeOverlayStyles.papillonEyelet2"></div>
          <div v-if="badgeOverlayStyles.papillonTopBleed" class="bleed papillonTopBleed" :style="badgeOverlayStyles.papillonTopBleed"></div>
          <div class="bleed papillonBottomBleed" :style="badgeOverlayStyles.papillonBottomBleed"></div>
          <div class="bleed papillonLeftBleed" :style="badgeOverlayStyles.papillonLeftBleed"></div>
          <div class="bleed papillonRightBleed" :style="badgeOverlayStyles.papillonRightBleed"></div>
        </template>
        <template v-if="this.badgeContent.origin === 'PapillonsV2'">
          <div class="eyelet papillonV2Eyelet" :style="badgeOverlayStyles.papillonV2Eyelet"></div>
          <div class="eyelet papillonV2EyeletCenter" :style="badgeOverlayStyles.papillonV2EyeletCenter"></div>
          <div class="eyelet papillonV2EyeletLeft" :style="badgeOverlayStyles.papillonV2EyeletLeft"></div>
          <div class="eyelet papillonV2EyeletRight" :style="badgeOverlayStyles.papillonV2EyeletRight"></div>
          <div class="bleed papillonV2TopBleed" :style="badgeOverlayStyles.papillonV2TopBleed"></div>
          <div class="bleed papillonV2LeftBleed" :style="badgeOverlayStyles.papillonV2LeftBleed"></div>
          <div class="bleed papillonV2RightBleed" :style="badgeOverlayStyles.papillonV2RightBleed"></div>
          <div v-if="badgeOverlayStyles.papillonV2BottomBleed" class="bleed papillonV2BottomBleed" :style="badgeOverlayStyles.papillonV2BottomBleed"></div>
          <div v-if="badgeOverlayStyles.papillonV2EyeletBottomMain" class="eyelet papillonV2Eyelet" :style="badgeOverlayStyles.papillonV2EyeletBottomMain"></div>
          <div v-if="badgeOverlayStyles.papillonV2EyeletBottomCenter" class="eyelet papillonV2EyeletCenter" :style="badgeOverlayStyles.papillonV2EyeletBottomCenter"></div>
          <div v-if="badgeOverlayStyles.papillonV2EyeletBottomLeft" class="eyelet papillonV2EyeletLeft" :style="badgeOverlayStyles.papillonV2EyeletBottomLeft"></div>
          <div v-if="badgeOverlayStyles.papillonV2EyeletBottomRight" class="eyelet papillonV2EyeletRight" :style="badgeOverlayStyles.papillonV2EyeletBottomRight"></div>
        </template>
        <template v-if="this.badgeContent.origin === '100x130'">
          <div class="eyelet badge100x130EyeletLeft" :style="badgeOverlayStyles.badge100x130EyeletLeft"></div>
          <div class="eyelet badge100x130EyeletCenter" :style="badgeOverlayStyles.badge100x130EyeletCenter"></div>
          <div class="eyelet badge100x130EyeletCenterDot" :style="badgeOverlayStyles.badge100x130EyeletCenterDot"></div>
          <div class="eyelet badge100x130EyeletRight" :style="badgeOverlayStyles.badge100x130EyeletRight"></div>
          <div class="bleed badge100x130TopBleed" :style="badgeOverlayStyles.badge100x130TopBleed"></div>
          <div class="bleed badge100x130LeftBleed" :style="badgeOverlayStyles.badge100x130LeftBleed"></div>
          <div class="bleed badge100x130RightBleed" :style="badgeOverlayStyles.badge100x130RightBleed"></div>
          <div v-if="badgeOverlayStyles.badge100x130BottomBleed" class="bleed badge100x130BottomBleed" :style="badgeOverlayStyles.badge100x130BottomBleed"></div>
          <div v-if="badgeOverlayStyles.badge100x130EyeletBottomLeft" class="eyelet badge100x130EyeletLeft" :style="badgeOverlayStyles.badge100x130EyeletBottomLeft"></div>
          <div v-if="badgeOverlayStyles.badge100x130EyeletBottomCenter" class="eyelet badge100x130EyeletCenter" :style="badgeOverlayStyles.badge100x130EyeletBottomCenter"></div>
          <div v-if="badgeOverlayStyles.badge100x130EyeletBottomCenterDot" class="eyelet badge100x130EyeletCenterDot" :style="badgeOverlayStyles.badge100x130EyeletBottomCenterDot"></div>
          <div v-if="badgeOverlayStyles.badge100x130EyeletBottomRight" class="eyelet badge100x130EyeletRight" :style="badgeOverlayStyles.badge100x130EyeletBottomRight"></div>
        </template>
        <template v-if="this.badgeContent.origin === '100x120-bleed'">
          <div class="eyelet bleed120Eyelet" :style="badgeOverlayStyles.bleed120Eyelet"></div>
          <div class="bleed bleed120BottomBleed" :style="badgeOverlayStyles.bleed120BottomBleed"></div>
          <div class="bleed bleed120LeftBleed" :style="badgeOverlayStyles.bleed120LeftBleed"></div>
          <div class="bleed bleed120RightBleed" :style="badgeOverlayStyles.bleed120RightBleed"></div>
        </template>
        <template v-if="this.badgeContent.origin === '100x240-bleed'">
          <div class="eyelet bleed120Eyelet" :style="badgeOverlayStyles.bleed240Eyelet"></div>
          <div v-if="badgeOverlayStyles.bleed240Eyelet2" class="eyelet bleed120Eyelet" :style="badgeOverlayStyles.bleed240Eyelet2"></div>
          <div class="bleed bleed240TopBleed" :style="badgeOverlayStyles.bleed240TopBleed"></div>
          <div class="bleed bleed240BottomBleed" :style="badgeOverlayStyles.bleed240BottomBleed"></div>
          <div class="bleed bleed240LeftBleed" :style="badgeOverlayStyles.bleed240LeftBleed"></div>
          <div class="bleed bleed240RightBleed" :style="badgeOverlayStyles.bleed240RightBleed"></div>
        </template>
        <template v-if="this.badgeContent.origin === '86x120-bleed' || this.badgeContent.origin === '86x240-bleed'">
          <div class="eyelet bleed86Eyelet" :style="badgeOverlayStyles.bleed86Eyelet"></div>
          <div class="eyelet bleed86EyeletCenter" :style="badgeOverlayStyles.bleed86EyeletCenter"></div>
          <div class="eyelet bleed86EyeletLeft" :style="badgeOverlayStyles.bleed86EyeletLeft"></div>
          <div class="eyelet bleed86EyeletRight" :style="badgeOverlayStyles.bleed86EyeletRight"></div>
          <div class="bleed bleed86TopBleed" :style="badgeOverlayStyles.bleed86TopBleed"></div>
          <div class="bleed bleed86LeftBleed" :style="badgeOverlayStyles.bleed86LeftBleed"></div>
          <div class="bleed bleed86RightBleed" :style="badgeOverlayStyles.bleed86RightBleed"></div>
          <div v-if="badgeOverlayStyles.bleed86BottomBleed" class="bleed bleed86BottomBleed" :style="badgeOverlayStyles.bleed86BottomBleed"></div>
          <div v-if="badgeOverlayStyles.bleed86EyeletBottom" class="eyelet bleed86Eyelet" :style="badgeOverlayStyles.bleed86EyeletBottom"></div>
          <div v-if="badgeOverlayStyles.bleed86EyeletBottomCenter" class="eyelet bleed86EyeletCenter" :style="badgeOverlayStyles.bleed86EyeletBottomCenter"></div>
          <div v-if="badgeOverlayStyles.bleed86EyeletBottomLeft" class="eyelet bleed86EyeletLeft" :style="badgeOverlayStyles.bleed86EyeletBottomLeft"></div>
          <div v-if="badgeOverlayStyles.bleed86EyeletBottomRight" class="eyelet bleed86EyeletRight" :style="badgeOverlayStyles.bleed86EyeletBottomRight"></div>
        </template>
        <template v-if="this.badgeContent.origin === '96x134-bleed' || this.badgeContent.origin === '96x268-bleed'">
          <div class="eyelet bleed96EyeletLeft" :style="badgeOverlayStyles.bleed96EyeletLeft"></div>
          <div class="eyelet bleed96EyeletCenter" :style="badgeOverlayStyles.bleed96EyeletCenter"></div>
          <div class="eyelet bleed96EyeletCenterDot" :style="badgeOverlayStyles.bleed96EyeletCenterDot"></div>
          <div class="eyelet bleed96EyeletRight" :style="badgeOverlayStyles.bleed96EyeletRight"></div>
          <div class="bleed bleed96TopBleed" :style="badgeOverlayStyles.bleed96TopBleed"></div>
          <div class="bleed bleed96LeftBleed" :style="badgeOverlayStyles.bleed96LeftBleed"></div>
          <div class="bleed bleed96RightBleed" :style="badgeOverlayStyles.bleed96RightBleed"></div>
          <div v-if="badgeOverlayStyles.bleed96BottomBleed" class="bleed bleed96BottomBleed" :style="badgeOverlayStyles.bleed96BottomBleed"></div>
          <div v-if="badgeOverlayStyles.bleed96EyeletBottomLeft" class="eyelet bleed96EyeletLeft" :style="badgeOverlayStyles.bleed96EyeletBottomLeft"></div>
          <div v-if="badgeOverlayStyles.bleed96EyeletBottomCenter" class="eyelet bleed96EyeletCenter" :style="badgeOverlayStyles.bleed96EyeletBottomCenter"></div>
          <div v-if="badgeOverlayStyles.bleed96EyeletBottomCenterDot" class="eyelet bleed96EyeletCenterDot" :style="badgeOverlayStyles.bleed96EyeletBottomCenterDot"></div>
          <div v-if="badgeOverlayStyles.bleed96EyeletBottomRight" class="eyelet bleed96EyeletRight" :style="badgeOverlayStyles.bleed96EyeletBottomRight"></div>
        </template>
        <div v-if="isBadgeDoubled" class="foldSeparator"></div>
        <VueDragResize
          v-for="(item, itemID) in itemList"
          :key="`item-${itemID}`"
          :minh="10"
          :minw="10"
          :parentLimitation="true"
          :parentW="$refs.badgeBackground.clientWidth"
          :parentH="$refs.badgeBackground.clientHeight"
          :y="getItemSize(item).y"
          :x="getItemSize(item).x"
          :snapToGrid="snapToGrid || false"
          :w="getItemSize(item).w"
          :h="getItemSize(item).h"
          :isActive="selectedItemID === itemID"
          :gridX="gridStep"
          :gridY="gridStep"
          :class="showOverlays ? 'itemOverlay' : ''"
          :stickSize="10"
          :aspectRatio="restrainProportions"
          @resizestop="resize($event, itemID)"
          @dragstop="resize($event, itemID)"
          @activated="itemClick(itemID)"
          class="badgeItem"
        >
          <TextComponent v-if="item.type === 'text'" :id="`item-${itemID}`" :item="item" />
          <ImageComponent v-if="item.type === 'image'" :id="`item-${itemID}`" :item="item" />
          <QrComponent v-if="item.type === 'qr-code'" :id="`item-${itemID}`" :item="item" />
        </VueDragResize>
      </template>
    </div>
  </div>
  <!-- Deployed Badge Code -->
  <div v-else class="position-relative w-100 h-100">
    <img
      v-if="cardBackground"
      class="top-0 left-0 position-absolute w-100 h-100"
      :src="cardBackground"
      alt=""
    />
    <div
      class="position-absolute"
      v-for="(item, itemID) in itemList"
      :key="`item-${itemID}`"
      :print-disable="item.printDisabled === true ? 'True' : undefined"
      :style="`width: ${item.position ? item.position.percent.w || 0 : 0}%; height: ${
        item.position ? item.position.percent.h || 0 : 0
      }%; top: ${item.position ? item.position.percent.y || 0 : 0}%; left: ${
        item.position ? item.position.percent.x || 0 : 0
      }%;`"
    >
      <TextComponent
        v-if="item.type === 'text'"
        :id="`item-${itemID}`"
        :item="item"
        :deploymentMode="deploymentMode"
      />
      <ImageComponent
        v-if="item.type === 'image'"
        :id="`item-${itemID}`"
        :item="item"
        :deploymentMode="deploymentMode"
      />
      <QrComponent
        v-if="item.type === 'qr-code'"
        :id="`item-${itemID}`"
        :item="item"
        :deploymentMode="deploymentMode"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import VueDragResize from 'vue-drag-resize';
import ImageComponent from '@/components/Content/ImageComponent.vue';
import TextComponent from './Content/TextComponent.vue';
import QrComponent from './Content/QrComponent.vue';

// Overlay specs in mm — top/height are height-based and computed dynamically.
// widthMm: physical badge width (denominator for height = widthMm × ratioY / 100)
// baseRatioY: reference ratioY — if current ratioY ≥ baseRatioY × 1.8, badge is considered doubled
// topMm: distance from top edge in mm
// fromBottomMm: distance from bottom edge (top = 100% - (fromBottomMm + heightMm)%)
// heightMm: height in mm
// topIsFromBottom: anchor element to bottom (top = 100% - heightMm%)
// fillEndMm: element fills from topMm to (bottom - fillEndMm)
// bottomOverlays: overlays added only when badge height is doubled
const BADGE_OVERLAY_SPECS = {
  papillon: {
    widthMm: 100,
    baseRatioY: 120,
    overlays: {
      papillonEyelet: { topMm: 4.61, heightMm: 2.57 },
      papillonBottomBleed: { topIsFromBottom: true, heightMm: 4.10 },
      papillonLeftBleed: { topMm: 0, fillEndMm: 4.10 },
      papillonRightBleed: { topMm: 0, fillEndMm: 4.10 },
    },
    doubledOverlays: {
      papillonEyelet: { fromMiddleMm: 4.61, heightMm: 2.57 },
      papillonEyelet2: { belowMiddleMm: 4.61, heightMm: 2.57 },
      papillonTopBleed: { topMm: 0, heightMm: 4.10 },
      papillonBottomBleed: { topIsFromBottom: true, heightMm: 4.10 },
      papillonLeftBleed: { topMm: 4.10, fillEndMm: 4.10 },
      papillonRightBleed: { topMm: 4.10, fillEndMm: 4.10 },
    },
  },
  PapillonsV2: {
    widthMm: 86,
    baseRatioY: 136,
    overlays: {
      papillonV2Eyelet: { topMm: 8.63, heightMm: 2.47 },
      papillonV2EyeletCenter: { topMm: 7.58, heightMm: 3.09 },
      papillonV2EyeletLeft: { topMm: 7.67, heightMm: 4.58 },
      papillonV2EyeletRight: { topMm: 7.67, heightMm: 4.58 },
      papillonV2TopBleed: { topMm: 0, heightMm: 2.29 },
      papillonV2LeftBleed: { topMm: 2.29, fillEndMm: 0 },
      papillonV2RightBleed: { topMm: 2.29, fillEndMm: 0 },
    },
    bottomOverlays: {
      papillonV2BottomBleed: { fromBottomMm: 0, heightMm: 2.29 },
      papillonV2EyeletBottomMain: { fromBottomMm: 8.63, heightMm: 2.47 },
      papillonV2EyeletBottomCenter: { fromBottomMm: 7.58, heightMm: 3.09 },
      papillonV2EyeletBottomLeft: { fromBottomMm: 7.67, heightMm: 4.58 },
      papillonV2EyeletBottomRight: { fromBottomMm: 7.67, heightMm: 4.58 },
    },
  },
  '100x130': {
    widthMm: 96.5,
    baseRatioY: 139,
    overlays: {
      badge100x130EyeletLeft: { topMm: 8, heightMm: 3 },
      badge100x130EyeletCenter: { topMm: 8, heightMm: 3 },
      badge100x130EyeletCenterDot: { topMm: 6.2, heightMm: 4 },
      badge100x130EyeletRight: { topMm: 8, heightMm: 3 },
      badge100x130TopBleed: { topMm: 0, heightMm: 2.5 },
      badge100x130LeftBleed: { topMm: 2.5, fillEndMm: 0 },
      badge100x130RightBleed: { topMm: 2.5, fillEndMm: 0 },
    },
    bottomOverlays: {
      badge100x130BottomBleed: { fromBottomMm: 0, heightMm: 2.5 },
      badge100x130EyeletBottomLeft: { fromBottomMm: 8, heightMm: 3 },
      badge100x130EyeletBottomCenter: { fromBottomMm: 8, heightMm: 3 },
      badge100x130EyeletBottomCenterDot: { fromBottomMm: 6, heightMm: 4 },
      badge100x130EyeletBottomRight: { fromBottomMm: 8, heightMm: 3 },
    },
  },
  // Canvas is the full 107x125mm sheet (single 100x120mm panel, safe area
  // 100x120mm) + 3.5mm left/right bleed + 5mm bottom bleed only (top edge
  // is the fold, not a cut edge, so no top bleed). Printer's printable
  // width is only 104mm, so the outer bleed prints out of bounds.
  '100x120-bleed': {
    widthMm: 107,
    overlays: {
      bleed120Eyelet: { topMm: 4.61, heightMm: 2.57 },
      bleed120BottomBleed: { topIsFromBottom: true, heightMm: 5 },
      bleed120LeftBleed: { topMm: 0, fillEndMm: 5 },
      bleed120RightBleed: { topMm: 0, fillEndMm: 5 },
    },
  },
  // Canvas is the full 107x250mm sheet (two 100x120mm panels folded, safe
  // area 100x240mm) + 3.5mm left/right bleed + 5mm top/bottom bleed, inset
  // from the canvas edges rather than added beyond them. Printer's
  // printable width is only 104mm, so the outer bleed prints out of bounds.
  '100x240-bleed': {
    widthMm: 107,
    baseRatioY: 120,
    overlays: {},
    doubledOverlays: {
      bleed240Eyelet: { fromMiddleMm: 4.61, heightMm: 2.57 },
      bleed240Eyelet2: { belowMiddleMm: 4.61, heightMm: 2.57 },
      bleed240TopBleed: { topMm: 0, heightMm: 5 },
      bleed240BottomBleed: { topIsFromBottom: true, heightMm: 5 },
      bleed240LeftBleed: { topMm: 5, fillEndMm: 5 },
      bleed240RightBleed: { topMm: 5, fillEndMm: 5 },
    },
  },
  // Canvas is the full 96x125mm sheet (single 86x120mm Coccinelle panel,
  // safe area 86x120mm) + 5mm bleed on left/right/top only (bottom edge is
  // the fold, not a cut edge, so no bottom bleed this time). Eyelet
  // positions are the classic Coccinelle ones shifted down by the 5mm top
  // bleed so they stay at the same physical spot within the safe area.
  '86x120-bleed': {
    widthMm: 96,
    overlays: {
      bleed86Eyelet: { topMm: 13.63, heightMm: 2.47 },
      bleed86EyeletCenter: { topMm: 12.58, heightMm: 3.09 },
      bleed86EyeletLeft: { topMm: 12.67, heightMm: 4.58 },
      bleed86EyeletRight: { topMm: 12.67, heightMm: 4.58 },
      bleed86TopBleed: { topMm: 0, heightMm: 5 },
      bleed86LeftBleed: { topMm: 5, fillEndMm: 0 },
      bleed86RightBleed: { topMm: 5, fillEndMm: 0 },
    },
  },
  // Canvas is the full 96x250mm sheet (two 86x120mm Coccinelle panels
  // folded, safe area 86x240mm) + 5mm bleed on all four sides.
  '86x240-bleed': {
    widthMm: 96,
    baseRatioY: 120,
    overlays: {
      bleed86Eyelet: { topMm: 13.63, heightMm: 2.47 },
      bleed86EyeletCenter: { topMm: 12.58, heightMm: 3.09 },
      bleed86EyeletLeft: { topMm: 12.67, heightMm: 4.58 },
      bleed86EyeletRight: { topMm: 12.67, heightMm: 4.58 },
      bleed86TopBleed: { topMm: 0, heightMm: 5 },
      bleed86LeftBleed: { topMm: 5, fillEndMm: 5 },
      bleed86RightBleed: { topMm: 5, fillEndMm: 5 },
    },
    bottomOverlays: {
      bleed86EyeletBottom: { fromBottomMm: 13.63, heightMm: 2.47 },
      bleed86EyeletBottomCenter: { fromBottomMm: 12.58, heightMm: 3.09 },
      bleed86EyeletBottomLeft: { fromBottomMm: 12.67, heightMm: 4.58 },
      bleed86EyeletBottomRight: { fromBottomMm: 12.67, heightMm: 4.58 },
      bleed86BottomBleed: { fromBottomMm: 0, heightMm: 5 },
    },
  },
  // Canvas is the full 102x138mm sheet (single 96x134mm "10x13" panel, safe
  // area 96x134mm) + 3mm left/right bleed + 4mm top bleed only (bottom edge
  // is the fold, not a cut edge, so no bottom bleed this time). Eyelet
  // positions are the classic 100x130 ones shifted down by the 4mm top
  // bleed so they stay at the same physical spot within the safe area.
  '96x134-bleed': {
    widthMm: 102,
    overlays: {
      bleed96EyeletLeft: { topMm: 12, heightMm: 3 },
      bleed96EyeletCenter: { topMm: 12, heightMm: 3 },
      bleed96EyeletCenterDot: { topMm: 10.2, heightMm: 4 },
      bleed96EyeletRight: { topMm: 12, heightMm: 3 },
      bleed96TopBleed: { topMm: 0, heightMm: 4 },
      bleed96LeftBleed: { topMm: 4, fillEndMm: 0 },
      bleed96RightBleed: { topMm: 4, fillEndMm: 0 },
    },
  },
  // Canvas is the full 102x276mm sheet (two 96x134mm panels folded, safe
  // area 96x268mm) + 3mm left/right bleed + 4mm top/bottom bleed.
  '96x268-bleed': {
    widthMm: 102,
    baseRatioY: 120,
    overlays: {
      bleed96EyeletLeft: { topMm: 12, heightMm: 3 },
      bleed96EyeletCenter: { topMm: 12, heightMm: 3 },
      bleed96EyeletCenterDot: { topMm: 10.2, heightMm: 4 },
      bleed96EyeletRight: { topMm: 12, heightMm: 3 },
      bleed96TopBleed: { topMm: 0, heightMm: 4 },
      bleed96LeftBleed: { topMm: 4, fillEndMm: 4 },
      bleed96RightBleed: { topMm: 4, fillEndMm: 4 },
    },
    bottomOverlays: {
      bleed96EyeletBottomLeft: { fromBottomMm: 12, heightMm: 3 },
      bleed96EyeletBottomCenter: { fromBottomMm: 12, heightMm: 3 },
      bleed96EyeletBottomCenterDot: { fromBottomMm: 10.2, heightMm: 4 },
      bleed96EyeletBottomRight: { fromBottomMm: 12, heightMm: 3 },
      bleed96BottomBleed: { fromBottomMm: 0, heightMm: 4 },
    },
  },
};

export default {
  name: 'BadgePreview',
  components: {
    QrComponent,
    ImageComponent,
    VueDragResize,
    TextComponent,
  },
  props: {
    deploymentMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.isLoaded = true;
    });
    this.$store.watch(
      (__, getters) => getters.googleFonts,
      () => {
        this.updateFonts();
      },
    );
    this.updateFonts();
  },
  data() {
    return {
      isLoaded: false,
      forceKeepRatio: false,
    };
  },
  computed: {
    ...mapGetters([
      'badgeContent',
      'zoomLevel',
      'itemList',
      'selectedItemID',
      'showOverlays',
      'gridStep',
      'snapToGrid',
      'keepRatio',
    ]),
    cardStyle() {
      const out = {};
      out.width = '100%';
      if (this.badgeContent.origin === 'CR80') out.borderRadius = '8px';
      if (this.badgeContent.origin === 'papillon') {
        out.borderRadius = '8px';
      }
      out.backgroundColor = this.badgeContent.backgroundColor.hex8 || 'white';
      out['--bs-aspect-ratio'] = `${
        this.badgeContent.orientation === 'v' ?
          this.badgeContent.format.ratioY :
          this.badgeContent.format.ratioX
      }%`;
      return out;
    },
    cardBackground() {
      return this.badgeContent.backgroundImage || undefined;
    },
    isBadgeDoubled() {
      const spec = BADGE_OVERLAY_SPECS[this.badgeContent.origin];
      return !!(spec && spec.baseRatioY && this.badgeContent.format.ratioY >= spec.baseRatioY * 1.8);
    },
    badgeOverlayStyles() {
      const spec = BADGE_OVERLAY_SPECS[this.badgeContent.origin];
      if (!spec) return {};
      const heightMm = (spec.widthMm * this.badgeContent.format.ratioY) / 100;
      const pct = (mm) => `${((mm / heightMm) * 100).toFixed(2)}%`;
      const isDoubled = spec.baseRatioY && this.badgeContent.format.ratioY >= spec.baseRatioY * 1.8;
      let allOverlays;
      if (isDoubled && spec.doubledOverlays) {
        allOverlays = spec.doubledOverlays;
      } else if (isDoubled && spec.bottomOverlays) {
        allOverlays = { ...spec.overlays, ...spec.bottomOverlays };
      } else {
        allOverlays = spec.overlays;
      }
      return Object.entries(allOverlays).reduce((acc, [key, o]) => {
        const style = {};
        if (o.fromMiddleMm !== undefined) {
          style.top = `calc(50% - ${pct(o.fromMiddleMm + o.heightMm)})`;
        } else if (o.belowMiddleMm !== undefined) {
          style.top = `calc(50% + ${pct(o.belowMiddleMm)})`;
        } else if (o.fromBottomMm !== undefined) {
          style.top = `calc(100% - ${pct(o.fromBottomMm + o.heightMm)})`;
        } else if (o.topIsFromBottom) {
          style.top = `calc(100% - ${pct(o.heightMm)})`;
        } else if (o.topMm !== undefined) {
          style.top = pct(o.topMm);
        }
        if (o.heightMm !== undefined) style.height = pct(o.heightMm);
        if (o.fillEndMm !== undefined) style.height = `calc(100% - ${pct(o.topMm + o.fillEndMm)})`;
        acc[key] = style;
        return acc;
      }, {});
    },
    gridStyle() {
      const out = {};
      out.backgroundImage =
        'repeating-linear-gradient(#ddd 0 1px, transparent 1px 100%), repeating-linear-gradient(90deg, #ddd 0 1px, transparent 1px 100%)';
      out.backgroundSize = `${this.gridStep}px ${this.gridStep}px`;
      return out;
    },
    restrainProportions() {
      return this.keepRatio || this.forceKeepRatio;
    },
  },
  methods: {
    updateFonts() {
      if (this.deploymentMode) return;
      let fontsCSS = '';
      this.$store.dispatch('getImportedFontCSS').then((fonts) => {
        fontsCSS = fonts;
        const head = this.$refs.badgeContent;
        if (head === undefined || head === null) return;
        const style = document.createElement('style');
        style.id = 'fontsList';
        const oldNode = document.getElementById('fontsList');
        if (oldNode !== null && head.contains(oldNode)) head.removeChild(oldNode);
        if (fontsCSS === '') return;
        head.appendChild(style);
        style.type = 'text/css';
        style.appendChild(document.createTextNode(fontsCSS));
      });
    },
    reload() {
      this.isLoaded = false;
      this.itemList.forEach((item) => {
        if (item.position) item.position = { percent: item.position.percent };
      });
      this.$nextTick(() => {
        this.isLoaded = true;
      });
    },
    getItemSize(item) {
      if (!item.position)
        return {
          x: 100,
          y: 100,
          h: 100,
          w: 100,
        };

      const VPH = this.$refs.badgeBackground.clientHeight;
      const VPW = this.$refs.badgeBackground.clientWidth;

      if (!item.position.x) item.position.x = (VPW * item.position.percent.x) / 100;
      if (!item.position.y) item.position.y = (VPH * item.position.percent.y) / 100;
      if (!item.position.w) item.position.w = (VPW * item.position.percent.w) / 100;
      if (!item.position.h) item.position.h = (VPH * item.position.percent.h) / 100;

      return item.position;
    },
    itemClick(itemID) {
      this.$store.commit('setSelectedItem', { selectedItem: itemID, dbSync: true });
      this.$EventBus.$emit('editItem', itemID);
    },
    resize(event, idx) {
      const itemsTmp = _.cloneDeep(this.itemList);
      itemsTmp[idx].position = {
        ...(itemsTmp[idx].position || {}),
        percent: {
          h: ((100 * event.height) / this.$refs.badgeBackground.clientHeight).toFixed(6),
          w: ((100 * event.width) / this.$refs.badgeBackground.clientWidth).toFixed(6),
          x: ((100 * event.left) / this.$refs.badgeBackground.clientWidth).toFixed(6),
          y: ((100 * event.top) / this.$refs.badgeBackground.clientHeight).toFixed(6),
        },
      };
      this.$store.commit('setBadgeContent', {
        content: { ...this.badgeContent, items: itemsTmp },
        dbSync: true,
      });
    },
    addItems(itemType) {
      const id = this.$chance.string({
        length: 5,
        casing: 'upper',
        alpha: true,
        numeric: false,
      });
      const itemData = { type: itemType, name: `${itemType}-${id}` };
      if (itemType === 'text') itemData.text = 'Votre texte ici';
      if (itemType === 'image')
        itemData.backgroundImage =
          'https://placehold.co/600x400?text=Image';
      this.$store.commit('addItem', { itemData, dbSync: true });
      this.$store.commit('setSelectedItem', {
        selectedItem: this.itemList.length - 1,
        dbSync: true,
      });
      this.$EventBus.$emit('editItem', this.itemList.length - 1);
    },
  },
};
</script>

<style scoped>
.foldSeparator {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  border-top: 2px dashed rgba(0, 0, 0, 0.35);
  pointer-events: none;
  z-index: 10;
}

.eyelet {
  background: black;
  z-index: 1;
  position: absolute;
}
.papillonEyelet {
  width: 15.88%;
  border-radius: 9999px;
  left: calc(50% - 7.94%);
}
.papillonV2Eyelet {
  background: black;
  width: 14.34%;
  border-radius: 9999px;
  left: calc(50% - 7.17%);
}
.papillonV2EyeletCenter {
  background: black;
  width: 3.59%;
  border-radius: 50%;
  left: calc(50% - 1.79%);
}
.papillonV2EyeletLeft {
  background: black;
  width: 5.33%;
  border-radius: 50%;
  left: calc(15.5% - 2.66%);
}
.papillonV2EyeletRight {
  background: black;
  width: 5.33%;
  border-radius: 50%;
  left: calc(84.5% - 2.66%);
}

.bleed {
  background: linear-gradient(
    45deg,
    rgba(255, 0, 0, 0.4) 12.5%,
    transparent 12.5%,
    transparent 37.5%,
    rgba(255, 0, 0, 0.4) 37.5%,
    rgba(255, 0, 0, 0.4) 62.5%,
    transparent 62.5%,
    transparent 87.5%,
    rgba(255, 0, 0, 0.4) 87.5%
  );
  background-size: 20px 20px;
  position: absolute;
  z-index: 1;
}

.papillonTopBleed {
  width: 100%;
}
.papillonBottomBleed {
  width: 100%;
}
.papillonLeftBleed {
  width: 1.92%;
  left: 0px;
}
.papillonRightBleed {
  width: 1.92%;
  left: calc(100% - 1.92%);
}

.papillonV2TopBleed {
  width: 100%;
  top: 0px;
}
.papillonV2BottomBleed {
  width: 100%;
}
.papillonV2LeftBleed {
  width: 2.22%;
  left: 0px;
}
.papillonV2RightBleed {
  width: 2.22%;
  left: calc(100% - 2.22%);
}

.badge100x130EyeletLeft {
  width: 15.54%;
  border-radius: 9999px;
  left: calc(15.5% - 7.77%);
}
.badge100x130EyeletCenter {
  width: 15.54%;
  border-radius: 9999px;
  left: calc(50% - 7.77%);
}
.badge100x130EyeletCenterDot {
  width: 4.66%;
  border-radius: 50%;
  left: calc(50% - 2.33%);
}
.badge100x130EyeletRight {
  width: 15.54%;
  border-radius: 9999px;
  left: calc(84.5% - 7.77%);
}

.badge100x130TopBleed {
  width: 100%;
  top: 0px;
}
.badge100x130BottomBleed {
  width: 100%;
}
.badge100x130LeftBleed {
  width: 2.07%;
  left: 0px;
}
.badge100x130RightBleed {
  width: 2.07%;
  left: calc(100% - 2.07%);
}

.bleed120Eyelet {
  width: 14.84%;
  border-radius: 9999px;
  left: calc(50% - 7.42%);
}

.bleed120BottomBleed {
  width: 100%;
}
.bleed120LeftBleed {
  width: 3.27%;
  left: 0px;
}
.bleed120RightBleed {
  width: 3.27%;
  left: calc(100% - 3.27%);
}

.bleed240TopBleed {
  width: 100%;
  top: 0px;
}
.bleed240BottomBleed {
  width: 100%;
}
.bleed240LeftBleed {
  width: 3.27%;
  left: 0px;
}
.bleed240RightBleed {
  width: 3.27%;
  left: calc(100% - 3.27%);
}

.bleed86Eyelet {
  width: 12.85%;
  border-radius: 9999px;
  left: calc(50% - 6.42%);
}
.bleed86EyeletCenter {
  width: 3.22%;
  border-radius: 50%;
  left: calc(50% - 1.61%);
}
.bleed86EyeletLeft {
  width: 4.78%;
  border-radius: 50%;
  left: calc(19.09% - 2.39%);
}
.bleed86EyeletRight {
  width: 4.78%;
  border-radius: 50%;
  left: calc(80.91% - 2.39%);
}

.bleed86TopBleed {
  width: 100%;
  top: 0px;
}
.bleed86BottomBleed {
  width: 100%;
}
.bleed86LeftBleed {
  width: 5.21%;
  left: 0px;
}
.bleed86RightBleed {
  width: 5.21%;
  left: calc(100% - 5.21%);
}

.bleed96EyeletLeft {
  width: 14.71%;
  border-radius: 9999px;
  left: calc(17.61% - 7.35%);
}
.bleed96EyeletCenter {
  width: 14.71%;
  border-radius: 9999px;
  left: calc(50% - 7.35%);
}
.bleed96EyeletCenterDot {
  width: 4.41%;
  border-radius: 50%;
  left: calc(50% - 2.21%);
}
.bleed96EyeletRight {
  width: 14.71%;
  border-radius: 9999px;
  left: calc(82.39% - 7.35%);
}

.bleed96TopBleed {
  width: 100%;
  top: 0px;
}
.bleed96BottomBleed {
  width: 100%;
}
.bleed96LeftBleed {
  width: 2.94%;
  left: 0px;
}
.bleed96RightBleed {
  width: 2.94%;
  left: calc(100% - 2.94%);
}

.badgeItem {
  height: unset;
  width: unset;
}

.itemOverlay {
  border: 1px dashed var(--bs-secondary);
}

.itemOverlay.active {
  border: 2px dashed var(--bs-success);
  z-index: 100 !important;
}

.vdr.active::before {
  outline: unset !important;
}
</style>

<style></style>
